import { ChevronDown } from "lucide-react";
import type { ReactNode } from "react";

interface SettingsGroupProps {
	header: ReactNode;
	description?: ReactNode;
	children: ReactNode;
	collapsible?: boolean;
}

export function SettingsGroup({
	header,
	description,
	children,
	collapsible = false,
}: SettingsGroupProps) {
	const surface =
		"min-w-0 rounded-lg border-[1.5px] border-card-border bg-card shadow-card";
	const heading =
		"px-4 py-4 sm:px-6 [&_h3]:mb-0 [&_h3]:text-lg [&_h3]:font-bold [&_h4]:text-lg [&_h4]:font-bold";
	const body = (
		<div className="space-y-4 border-t border-card-border p-4 sm:p-6 [&>div:first-child]:mt-0">
			{children}
		</div>
	);
	return collapsible ? (
		<details className={`${surface} group/settings`}>
			<summary
				className={`${heading} flex cursor-pointer list-none items-center gap-2 text-lg font-bold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring [&::-webkit-details-marker]:hidden`}
			>
				<span className="min-w-0 flex-1 text-left rtl:text-right">
					{header}
					{description && (
						<span className="mt-1 block text-left text-sm font-normal leading-6 text-muted-foreground rtl:text-right">
							{description}
						</span>
					)}
				</span>
				<ChevronDown
					aria-hidden="true"
					className="h-4 w-4 shrink-0 group-open/settings:rotate-180"
				/>
			</summary>
			{body}
		</details>
	) : (
		<section className={surface}>
			<div className={`${heading} text-left rtl:text-right`}>
				{header}
				{description && (
					<p className="mt-1 text-left text-sm font-normal leading-6 text-muted-foreground rtl:text-right">
						{description}
					</p>
				)}
			</div>
			{body}
		</section>
	);
}
